/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import { lAC_GetCartGratuityDataFromChannelProfileAsync } from '../custom-actions/DataActionExtension.g';
import { IGetCartGratuityDataResponse, ILAC_AuthToken } from '../custom-actions/DataServiceEntities.g';
import { withFreshToken } from '../utils/authService';

/**
 * GetCartGratuity Input Action
 */
export class GetCartGratuityInput implements Msdyn365.IActionInput {
    public authTokenCookie: ILAC_AuthToken;
    public cartId: string;
    public channelId: number;
    public customerId: string;

    constructor(cartId: string, channelId: number, customerId: string, authTokenCookie: ILAC_AuthToken) {
        this.authTokenCookie = authTokenCookie;
        this.cartId = cartId;
        this.channelId = channelId;
        this.customerId = customerId;
    }

    // a cache object type and an appropriate cache key
    public getCacheKey = () => `GETCARTGRATUITYDATAFROMCHANNELPROFILE${this.cartId}_${this.channelId}`;
    public getCacheObjectType = () => 'GETCARTGRATUITYDATAFROMCHANNELPROFILE';
    public dataCacheType = (): Msdyn365.CacheType => 'none';
}

async function getCartGratuityAsync(
    input: GetCartGratuityInput,
    ctx: Msdyn365.IActionContext
): Promise<IGetCartGratuityDataResponse | undefined> {
    try {
        const result = await withFreshToken(ctx, input.authTokenCookie, async carried =>
            lAC_GetCartGratuityDataFromChannelProfileAsync({ callerContext: ctx }, carried, input.cartId, input.channelId, input.customerId)
        );
        if (result) {
            return result;
        }
    } catch (error) {
        console.log('Error getting cart gratuity:', error);
        throw error;
    }
    return undefined;
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IGetCartGratuityDataResponse | undefined>>getCartGratuityAsync,
    id: 'GetCartGratuityDataFromChannelProfile'
});
